// extracted by mini-css-extract-plugin
export default {"inner":"OrdersSkeleton_inner_OkDDy"};